"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ledgerItemsCreateConfig = void 0;
exports.ledgerItemsCreateConfig = {
    canCreateLedgerItems: true,
    showCreateNewLedgerItemButton: true,
};
